module.exports = __webpack_public_path__ + "img/globe-network-1294.cfd5e33d.svg";